document.documentElement.classList.remove('no-js');
document.documentElement.classList.add('js');

const body = document.body;
const menu = document.querySelector('[data-menu]');
const menuToggle = document.querySelector('[data-menu-toggle]');

const setMenu = (open) => {
  if (!menu || !menuToggle) return;
  menu.hidden = !open;
  menuToggle.setAttribute('aria-expanded', String(open));
  body.toggleAttribute('data-menu-open', open);
};

menuToggle?.addEventListener('click', () => setMenu(menuToggle.getAttribute('aria-expanded') !== 'true'));
document.querySelectorAll('[data-menu-close]').forEach((button) => button.addEventListener('click', () => setMenu(false)));

const searchToggle = document.querySelector('[data-search-toggle]');
const searchPanel = document.querySelector('[data-search-panel]');

const setSearch = (open) => {
  if (!searchToggle || !searchPanel) return;
  searchToggle.setAttribute('aria-expanded', String(open));
  searchPanel.hidden = !open;
  if (open) searchPanel.querySelector('input[type="search"]')?.focus();
};

searchToggle?.addEventListener('click', () => setSearch(searchToggle.getAttribute('aria-expanded') !== 'true'));

document.addEventListener('keydown', (event) => {
  if (event.key !== 'Escape') return;
  setMenu(false);
  setSearch(false);
  document.querySelectorAll('[data-filter-panel].is-open').forEach((panel) => panel.classList.remove('is-open'));
  body.removeAttribute('data-filter-open');
});

document.querySelectorAll('[data-filter-toggle]').forEach((button) => {
  button.addEventListener('click', () => {
    const panel = document.querySelector('[data-filter-panel]');
    panel?.classList.add('is-open');
    body.setAttribute('data-filter-open', '');
  });
});

document.querySelectorAll('[data-filter-close]').forEach((button) => {
  button.addEventListener('click', () => {
    button.closest('[data-filter-panel]')?.classList.remove('is-open');
    body.removeAttribute('data-filter-open');
  });
});

document.querySelectorAll('[data-quantity]').forEach((control) => {
  const input = control.querySelector('input');
  control.querySelector('[data-quantity-minus]')?.addEventListener('click', () => {
    input.value = Math.max(Number(input.min || 1), Number(input.value || 1) - 1);
  });
  control.querySelector('[data-quantity-plus]')?.addEventListener('click', () => {
    input.value = Number(input.value || 1) + 1;
  });
});

document.querySelectorAll('[data-variant-select]').forEach((select) => {
  select.addEventListener('change', () => {
    const option = select.options[select.selectedIndex];
    const shell = select.closest('[data-product-shell]');
    const price = shell?.querySelector('[data-product-price]');
    const compare = shell?.querySelector('[data-product-compare]');
    const availability = shell?.querySelector('[data-product-availability]');
    const button = shell?.querySelector('[data-add-button]');
    const stickyPrice = shell?.querySelector('[data-sticky-price]');
    const stickyButton = shell?.querySelector('[data-sticky-add]');
    const galleryImage = shell?.querySelector('[data-gallery-main]');
    const dynamicCheckout = shell?.querySelector('[data-dynamic-checkout]');
    const hasValidPrice = option.dataset.priceValid === 'true';
    const available = option.dataset.available === 'true' && hasValidPrice;
    if (price) price.textContent = option.dataset.price || '';
    if (stickyPrice) stickyPrice.textContent = option.dataset.price || '';
    if (compare) {
      compare.textContent = option.dataset.compare || '';
      compare.hidden = !option.dataset.compare;
    }
    if (availability) {
      availability.lastChild.textContent = hasValidPrice ? (available ? ` ${availability.dataset.availableLabel}` : ` ${availability.dataset.soldLabel}`) : ` ${availability.dataset.priceUnavailableLabel}`;
      availability.querySelector('span')?.classList.toggle('is-available', available);
    }
    if (button) {
      button.disabled = !available;
      const text = button.querySelector('[data-add-text]');
      if (text) text.textContent = hasValidPrice ? (available ? button.dataset.addLabel : button.dataset.soldLabel) : button.dataset.unavailableLabel;
    }
    if (stickyButton) {
      stickyButton.disabled = !available;
      stickyButton.textContent = hasValidPrice ? (available ? button.dataset.addLabel : button.dataset.soldLabel) : button.dataset.unavailableLabel;
    }
    if (dynamicCheckout) dynamicCheckout.hidden = !available;
    if (galleryImage && option.dataset.image) {
      galleryImage.src = option.dataset.image;
      galleryImage.srcset = option.dataset.imageSrcset || '';
      galleryImage.alt = option.dataset.imageAlt || '';
      galleryImage.dataset.zoomSource = option.dataset.zoomImage || option.dataset.image;
    }
    if (option.dataset.url && history.replaceState) history.replaceState({}, '', option.dataset.url);
  });
});

document.querySelectorAll('[data-sticky-add]').forEach((button) => {
  button.addEventListener('click', () => {
    const addButton = button.closest('[data-product-shell]')?.querySelector('[data-add-button]');
    if (addButton && !addButton.disabled) addButton.click();
  });
});

document.querySelectorAll('[data-product-thumb]').forEach((thumb) => {
  thumb.addEventListener('click', () => {
    const gallery = thumb.closest('[data-gallery]');
    const image = gallery?.querySelector('[data-gallery-main]');
    if (!image) return;
    image.src = thumb.dataset.src;
    image.srcset = thumb.dataset.srcset || '';
    image.alt = thumb.dataset.alt || '';
    image.dataset.zoomSource = thumb.dataset.zoomSrc || thumb.dataset.src;
    gallery.querySelectorAll('[data-product-thumb]').forEach((item) => item.removeAttribute('aria-current'));
    thumb.setAttribute('aria-current', 'true');
  });
});

document.querySelectorAll('[data-product-shell]').forEach((shell) => {
  const dialog = shell.querySelector('[data-zoom-dialog]');
  const galleryImage = shell.querySelector('[data-gallery-main]');
  const zoomImage = shell.querySelector('[data-zoom-image]');
  shell.querySelector('[data-product-zoom]')?.addEventListener('click', () => {
    if (!dialog || !galleryImage || !zoomImage) return;
    zoomImage.src = galleryImage.dataset.zoomSource || galleryImage.currentSrc || galleryImage.src;
    zoomImage.alt = galleryImage.alt;
    dialog.showModal();
  });
  shell.querySelector('[data-zoom-close]')?.addEventListener('click', () => dialog?.close());
  dialog?.addEventListener('click', (event) => {
    if (event.target === dialog) dialog.close();
  });
});

document.querySelectorAll('[data-sale-countdown]').forEach((countdown) => {
  const end = Date.parse(countdown.dataset.saleEnd || '');
  const days = countdown.querySelector('[data-countdown-days]');
  const hours = countdown.querySelector('[data-countdown-hours]');
  const minutes = countdown.querySelector('[data-countdown-minutes]');
  const seconds = countdown.querySelector('[data-countdown-seconds]');
  if (!Number.isFinite(end)) {
    countdown.hidden = true;
    return;
  }
  const update = () => {
    const remaining = end - Date.now();
    if (remaining <= 0) {
      countdown.hidden = true;
      return false;
    }
    const totalSeconds = Math.floor(remaining / 1000);
    if (days) days.textContent = String(Math.floor(totalSeconds / 86400)).padStart(2, '0');
    if (hours) hours.textContent = String(Math.floor(totalSeconds / 3600) % 24).padStart(2, '0');
    if (minutes) minutes.textContent = String(Math.floor(totalSeconds / 60) % 60).padStart(2, '0');
    if (seconds) seconds.textContent = String(totalSeconds % 60).padStart(2, '0');
    return true;
  };
  if (update()) {
    const timer = window.setInterval(() => {
      if (!update()) window.clearInterval(timer);
    }, 1000);
  }
});
